import { useTranslation } from 'react-i18next';

import { MultiSelect, MultiSelectProps } from '@mantine/core';

import { useGetOrganizationTypesQuery } from '@api/organizationType.api';

export default function OrganizationTypeSelector(props: MultiSelectProps) {
  const { t } = useTranslation();
  const { data = [], isLoading } = useGetOrganizationTypesQuery();

  return (
    <MultiSelect
      label={t('selectors.organizationType.label')}
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : t('selectors.organizationType.placeholder')
      }
      data={data.map((organizationType) => ({
        label: organizationType.name,
        value: organizationType.name,
      }))}
      disabled={isLoading}
      {...props}
    />
  );
}
